module.exports = __webpack_public_path__ + "img/stop.11441e81.svg";